import { api } from "./client";

export interface CatacombsEnemyPreview {
  name: string;
  hp: number;
  is_boss: boolean;
}

export interface CatacombsFloorPreview {
  floor: number;
  is_boss: boolean;
  enemy_count: number;
  enemies: CatacombsEnemyPreview[];
  crypto_reward: number;
}

export interface CatacombsAutoClearState {
  available_today: boolean;
  in_progress: boolean;
  ready_to_claim: boolean;
  seconds_remaining: number;
  duration_seconds: number;
  skip_diamond_cost: number;
  vip_skip_free?: boolean;
}

export interface CatacombsState {
  unlocked: boolean;
  unlock_level: number;
  highest_cleared: number;
  max_floor: number;
  next_floor: number | null;
  cleared_all: boolean;
  crypto: number;
  next_preview: CatacombsFloorPreview | null;
  auto_clear: CatacombsAutoClearState;
}

export interface CatacombsFightResult {
  battle_id: number;
  floor: number;
  won: boolean;
  rewards: Record<string, unknown>;
  info_messages: string[];
  state: CatacombsState;
}

export interface CatacombsShopItem {
  code: string;
  name: string;
  kind: string;
  crypto_cost: number;
  description: string;
}

export interface CatacombsShop {
  crypto: number;
  items: CatacombsShopItem[];
}

export const catacombsApi = {
  getState: () => api.get<CatacombsState>("/catacombs/state"),

  fight: () => api.post<CatacombsFightResult>("/catacombs/fight"),

  autoClearStart: () => api.post<{ ok: boolean; state: CatacombsState }>("/catacombs/auto-clear/start"),

  autoClearClaim: () =>
    api.post<{ ok: boolean; rewards: Record<string, unknown>; info_messages?: string[]; state: CatacombsState }>(
      "/catacombs/auto-clear/claim",
    ),

  autoClearSkip: () =>
    api.post<{
      ok: boolean;
      rewards: Record<string, unknown>;
      diamonds_spent: number;
      info_messages?: string[];
      state: CatacombsState;
    }>("/catacombs/auto-clear/skip"),

  getShop: () => api.get<CatacombsShop>("/catacombs/shop"),

  buyShopItem: (item_code: string) =>
    api.post<{ ok: boolean; message: string; shop: CatacombsShop }>("/catacombs/shop/buy", { item_code }),
};
